import { Link } from 'react-router-dom';
import { AuthLayout } from '@/components/AuthLayout';

export function NotFoundPage() {
  return (
    <AuthLayout title="Page not found">
      <p className="text-sm text-ink-soft">
        The page you tried to load doesn't exist.{' '}
        <Link to="/dashboard" className="text-accent-600 hover:underline">
          Back to dashboard
        </Link>
      </p>
    </AuthLayout>
  );
}
